import { render } from "./AddPoidsModal.vue?vue&type=template&id=7ed48ccc&ts=true"
import script from "./AddPoidsModal.vue?vue&type=script&lang=ts"
export * from "./AddPoidsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__